import { ref } from 'vue';

/**
 * usePagination 分頁管理 Hook
 *
 * 提供分頁狀態管理、事件處理和配置管理
 * 詳細使用說明請參考 docs/usePagination.md
 */

export default function usePagination(options = {}) {
    const pagination = ref({
        total: 0,
        current: 1,
        pageSize: options.pageSize || 20,
        showSizeChanger: true,
        pageSizeOptions: options.pageSizeOptions || ['10', '20', '50', '100'],
        defaultPageSize: options.pageSize || 20,
        size: 'small',
        position: ['bottomCenter'],
        showTotal: (total) => `總共 ${total} 筆`,
        locale: {
            items_per_page: '筆/頁'
        },
        ...options
    });

    /**
     * 更新分頁狀態
     * @param {Object} newPagination - 新的分頁配置
     */
    const updatePagination = (newPagination) => {
        pagination.value = {
            ...pagination.value,
            ...newPagination
        };
    };

    /**
     * 重置分頁到第一頁
     */
    const resetPagination = () => {
        pagination.value.current = 1;
    };

    // 設定事件處理函數
    pagination.value.onChange = (page, pageSize) => {
        updatePagination({ current: page, pageSize });
        if (options.onChange) {
            options.onChange(page, pageSize);
        }
    };

    pagination.value.onShowSizeChange = (current, size) => {
        updatePagination({ current: 1, pageSize: size });
        if (options.onShowSizeChange) {
            options.onShowSizeChange(current, size);
        }
    };

    return {
        pagination,
        updatePagination,
        resetPagination
    };
}
